import styled, { css } from "styled-components";
import { breakpoints, ColorTokens } from "@tvg/design-system";

const flexColumn = css`
  display: flex;
  flex-direction: column;
`;
const handleColor = (
  isTopStat: boolean | undefined,
  colorTokens: ColorTokens
) => (isTopStat ? colorTokens.background.positive : colorTokens.content.subtle);

export const Entry = styled.span<{
  isSire?: boolean;
  isDam?: boolean;
  isGrandDam?: boolean;
  hasGrandDamDescription?: boolean;
}>`
  color: ${({ theme }) => theme.colorTokens.content.subtle};
  margin: 2px 0;

  &:not(:last-child) {
    ${({ isDam, isSire, theme }) =>
      !isSire &&
      !isDam &&
      css`
        border-right: 1px solid ${theme.colorTokens.content.subtle3};
        margin-right: ${theme.space["space-1"]};
        padding-right: ${theme.space["space-1"]};
      `}
  }

  &::after {
    ${({ isSire, theme }) =>
      isSire &&
      css`
        content: "-";
        padding: 0 ${theme.space["space-1"]} 0 ${theme.space["space-1"]};
      `}
  }

  ${({ isGrandDam, hasGrandDamDescription, theme }) =>
    isGrandDam &&
    hasGrandDamDescription &&
    css`
      &::before {
        content: "by";
        padding-right: ${theme.space["space-1"]};
      }
    `}

  ${({ isGrandDam, hasGrandDamDescription, theme }) =>
    isGrandDam &&
    !hasGrandDamDescription &&
    css`
      &::before {
        content: "";
        border-left: 1px solid ${theme.colorTokens.content.subtle3};
        padding-left: ${theme.space["space-1"]};
      }
    `}
    ${({ isDam, theme }) =>
    isDam &&
    css`
      &:after {
        content: "";
        margin-right: ${theme.space["space-1"]};
      }
    `}
`;

const handleMarginLeft = (hasSilk: boolean) => (hasSilk ? "68" : "40");

export const AdvancedTextContainer = styled.div<{
  isScratched: boolean | undefined;
  isInlineHandicapping?: boolean;
  hasSilk: boolean;
  hasMobileOrder?: boolean;
}>`
  display: flex;
  justify-content: space-between;
  padding: ${({ theme }) =>
    `0 ${theme.space["space-4"]} ${theme.space["space-4"]} ${theme.space["space-4"]}`};
  ${({ isInlineHandicapping, hasSilk }) =>
    !isInlineHandicapping &&
    css`
      margin-left: ${handleMarginLeft(hasSilk)}px;
    `}
  gap: 8px;
  ${({ isScratched }) =>
    isScratched &&
    css`
      opacity: 0.4;
    `};

  @media screen and ${breakpoints.tablet.max.sm} {
    order: ${({ hasMobileOrder }) => (hasMobileOrder ? 1 : "initial")};
    justify-content: flex-start;
    gap: 0;
    margin-left: 0;
    flex-direction: column;
  }
`;

export const LeftSideContainer = styled.div<{ isWPSBetType: boolean }>`
  display: flex;
  flex-wrap: wrap;
  height: fit-content;
  ${({ isWPSBetType }) =>
    isWPSBetType &&
    css`
      max-width: 335px;
      width: 0;
      flex: 1;
    `}

  @media screen and ${breakpoints.tablet.max.sm} {
    max-width: initial;
    width: initial;
  }
`;

export const RightSideContainer = styled.div`
  display: flex;
  margin-right: 2px;
  gap: 8px;
  justify-content: flex-end;

  @media screen and ${breakpoints.tablet.max.sm} {
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 0;
    margin: 10px 0 0 0;
  }
`;

export const InfoContainer = styled.div`
  ${flexColumn};
  text-align: center;
  min-width: 50px;

  @media screen and ${breakpoints.tablet.max.sm} {
    flex-direction: row-reverse;
    align-items: center;
    text-align: left;
    min-width: initial;
    padding: 2px 0;
  }
`;

export const Info = styled.span<{
  isValue?: boolean;
  isTopStat?: boolean;
  isDescription?: boolean;
}>`
  white-space: nowrap;
  font-size: 12px;
  color: ${({ isDescription, theme, isTopStat }) =>
    isDescription
      ? theme.colorTokens.content.subtle2
      : handleColor(isTopStat, theme.colorTokens)};
  font-family: ${({ theme }) => theme.fonts.condensedRegular};
  line-height: 13.2px;
  ${({ isValue, theme }) =>
    isValue &&
    css`
      font-family: ${theme.fonts.medium};
      font-size: 14px;
      line-height: 17.5px;
      padding: 2px ${theme.space["space-3"]} 2px ${theme.space["space-3"]};
    `};

  @media screen and ${breakpoints.tablet.max.sm} {
    line-height: 1;
    ${({ isValue, theme }) =>
      isValue &&
      css`
        padding: 0;
        margin: 0 ${theme.space["space-5"]} 0 ${theme.space["space-1"]};
      `};
  }
`;
